module.exports = __webpack_public_path__ + "static/media/me.754447db.svg";